var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbMyOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.169,
    height: 15.999,
    viewBox: "0 0 17.169 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "db_my_order",
    transform: "translate(-9 -25.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8419",
    "data-name": "Path 8419",
    d: "M25.123,32.528h-.866a.853.853,0,0,0-.814-.626H22.52v-2.26a.238.238,0,0,0-.116-.211l-6.519-3.765a.241.241,0,0,0-.242,0L9.121,29.432A.243.243,0,0,0,9,29.643v7.531a.243.243,0,0,0,.122.211l6.522,3.765a.243.243,0,0,0,.122.033.256.256,0,0,0,.125-.033l3.432-1.98V40.6a1.03,1.03,0,0,0,1.039,1.033h4.762A1.036,1.036,0,0,0,26.169,40.6V33.577a1.05,1.05,0,0,0-1.046-1.049Zm-1.671-.139a.353.353,0,0,1,.353.353v.024a.353.353,0,0,1-.353.353H22.039a.353.353,0,0,1-.353-.353v-.024a.353.353,0,0,1,.353-.353Zm-7.687-6.231,2.71,1.565L12.44,31.207,9.73,29.642Zm-.231,14.359L9.487,37.033v-6.97l6.047,3.484Zm.231-7.391-2.838-1.639L18.962,28,21.8,29.642Zm3.557.45v5.031l-3.3,1.909v-6.97l6.013-3.484V31.9h.008a.853.853,0,0,0-.814.626h-.866a1.044,1.044,0,0,0-1.041,1.051Zm6.36,7.024a.549.549,0,0,1-.559.546H20.361a.543.543,0,0,1-.552-.546V33.577a.557.557,0,0,1,.552-.562h.875a.832.832,0,0,0,.8.591h1.4a.832.832,0,0,0,.8-.591h.875a.563.563,0,0,1,.559.562Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M337.235,279.592h.248a.237.237,0,0,0,0-.474h-.009v-.644h.654a.228.228,0,0,0,.225.16.238.238,0,0,0,.238-.237v-.16a.24.24,0,0,0-.24-.238h-1.117a.237.237,0,0,0-.235.238v1.117a.235.235,0,0,0,.235.237Z",
    transform: "translate(-316.57 -243.57)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M337.237,343.592h1.118a.237.237,0,0,0,.237-.237v-1.118a.237.237,0,0,0-.237-.237h-1.118a.237.237,0,0,0-.237.237v1.118a.237.237,0,0,0,.237.237Zm.237-1.118h.644v.644h-.644Z",
    transform: "translate(-316.57 -305.34)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M337.483,407.118h-.009v-.644h.641a.238.238,0,1,0,.477,0v-.229a.247.247,0,0,0-.24-.246h-1.117a.244.244,0,0,0-.235.246v1.117a.229.229,0,0,0,.235.229h.248a.237.237,0,0,0,0-.474Z",
    transform: "translate(-316.57 -367.077)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M355.665,284.608l-.7.7-.211-.211a.237.237,0,0,0-.335.335l.379.379a.237.237,0,0,0,.335,0l.862-.862a.237.237,0,0,0-.335-.335Z",
    transform: "translate(-333.318 -249.885)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M355.665,413.857l-.7.7-.211-.211a.237.237,0,1,0-.335.335l.379.379a.237.237,0,0,0,.335,0l.862-.862a.237.237,0,0,0-.335-.335Z",
    transform: "translate(-333.318 -374.601)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M415.618,295h-1.49a.237.237,0,1,0,0,.474h1.49a.237.237,0,0,0,0-.474Z",
    transform: "translate(-390.741 -259.997)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M415.618,359h-1.49a.237.237,0,1,0,0,.474h1.49a.237.237,0,0,0,0-.474Z",
    transform: "translate(-390.741 -321.771)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M415.618,423h-1.49a.237.237,0,1,0,0,.474h1.49a.237.237,0,0,0,0-.474Z",
    transform: "translate(-390.741 -383.501)",
    fill: "#676767"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbMyOrder);
export default __webpack_public_path__ + "static/media/db_my_order.370373f27f4c1fefcd8f90f68adba41b.svg";
export { ForwardRef as ReactComponent };